// @ts-nocheck
import {
  Autotriage_Verdict,
  AutotriageFeedback_Rating,
} from "@protos/ai/v1/triage";
import { FindingTriageState, IssueStatus } from "@protos/common/v1/common";
import {
  AggregateIssueState,
  Issue,
  ListIssuesResponse_IssueSummary,
} from "@protos/issues/v1/issues";

export const issueSummariesData: ListIssuesResponse_IssueSummary[] = [
  ListIssuesResponse_IssueSummary.create({
    reviewComments: [{ id: 1, body: "This is a comment" }],
    allRefs: [
      "refs/heads/master",
      "refs/heads/1",
      "refs/heads/2",
      "super/duper/long/branch/name/that/should/wrap/to/the/next/line/and/then/some/more/words/to/make/it/wrap/super/duper/long/branch/name/that/should/wrap/to/the/next/line/and/then/some/more/words/to/make/it/wrap/super/duper/long/branch/name/that/should/wrap/to/the/next/line/and/then/some/more/words/to/make/it/wrap",
      "refs/heads/3",
      "refs/heads/4",
      "refs/heads/5",
      "refs/heads/6",
      "refs/heads/7",
      "refs/heads/8",
      "refs/heads/9",
    ],
    triageCount: 0,
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19010,
      syntacticId: "7d2f0fcf4a904da97cb51dd78cd8a4fb",
      matchBasedId: null,
      message:
        "To ensure reproducible builds, pin Dockerfile `FROM` commands to a specific hash. You can find the hash by running `docker pull node` and then  specify it with `node:16-alpine@sha256:<hash goes here>`",
      check_id:
        "dockerfile.audit.dockerfile-source-not-pinned.dockerfile-source-not-pinned",
      path: "Dockerfile",
      line: 9,
      column: 1,
      end_line: 9,
      end_column: 20,
      severity: 2,
      references: ["https://stackoverflow.com/a/33511811/4965"],
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/dockerfile.audit.dockerfile-source-not-pinned.dockerfile-source-not-pinned",
      ruleset: "dockerfile",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      lastSeenScan: {
        id: 32378,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      history: [
        {
          note: "I think Jesse is the coolest dude on planet earth",
          state: "ignored",
          date: "Fri, 12 Aug 2022 17:39:26 GMT",
          actor: "chmccreery",
          history_type: "triage",
        },
        {
          note: "Couldn't agree more Clara!",
          state: "reopened",
          date: "Tue, 16 Aug 2022 16:14:29 GMT",
          actor: "adamboros",
          history_type: "triage",
        },
        {
          note: "😎",
          state: "",
          date: "Sat, 27 Aug 2022 02:42:17 GMT",
          actor: "jesse-r2c",
          history_type: "triage",
        },
        {
          note: "",
          state: "muted",
          date: "Sat, 27 Jan 2023 02:42:17 GMT",
          actor: null,
          history_type: "status",
        },
        {
          note: "",
          state: "unresolved",
          date: "Sat, 27 Jan 2023 02:42:17 GMT",
          actor: null,
          history_type: "status",
        },
      ],
      is_blocking: true,
      relatedIssues: [
        {
          id: 1,
          ref: "ayo",
        },
        {
          id: 2,
          ref: "waddup",
        },
        {
          id: 3,
          ref: "teehee",
        },
      ],
      lineOfCodeUrl:
        "https://github.com/returntocorp/semgrep-app/blob/20db25ee33ee73261a7be8f3a884991d484e2c39/server/semgrep_app/cloud_platform/registry/models/rules.py#L866",
      autotriage: {
        id: 1,
        issueId: 19010,
        verdict: Autotriage_Verdict.FALSE_POSITIVE,
        reason:
          "The matched code is a placeholder string and not an actual hard-coded credential.",
        feedback: {
          autotriageId: 1,
          rating: AutotriageFeedback_Rating.RATING_GOOD,
          comment: "Wonky indeed!",
        },
      },
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19009,
      syntacticId: "a8fdbbf5509824431b5e32bb83589af9",
      matchBasedId: null,
      check_id:
        "dockerfile.audit.dockerfile-source-not-pinned.dockerfile-source-not-pinned",
      path: "Dockerfile",
      line: 1,
      column: 1,
      end_line: 1,
      end_column: 26,
      message:
        "To ensure reproducible builds, pin Dockerfile `FROM` commands to a specific hash. You can find the hash by running `docker pull node` and then  specify it with `node:16@sha256:<hash goes here>`",
      severity: 2,
      references: ["https://stackoverflow.com/a/33511811/4965"],
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/dockerfile.audit.dockerfile-source-not-pinned.dockerfile-source-not-pinned",
      ruleset: "dockerfile",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
      relatedIssues: [],
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19008,
      syntacticId: "aac0f9eccd62847bd698b3bdfd2cdc7e",
      matchBasedId: null,
      check_id:
        "typescript.react.security.audit.react-unsanitized-property.react-unsanitized-property",
      path: "frontend/src/hacking-instructor/index.ts",
      line: 106,
      column: 3,
      end_line: 106,
      end_column: 43,
      message:
        "User controlled data in a `textBox` is an anti-pattern that can lead to XSS vulnerabilities",
      severity: 2,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/typescript.react.security.audit.react-unsanitized-property.react-unsanitized-property",
      ruleset: "typescript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19007,
      syntacticId: "7b3fd9b4a650bb5a947ec6369e49d740",
      matchBasedId: null,
      check_id:
        "javascript.jsonwebtoken.security.jwt-hardcode.hardcoded-jwt-secret",
      path: "lib/insecurity.js",
      line: 34,
      column: 36,
      end_line: 34,
      end_column: 112,
      message:
        "Hardcoded JWT secret or private key is used. This is a Insufficiently Protected Credentials weakness: https://cwe.mitre.org/data/definitions/522.html Consider using an appropriate security mechanism to protect the credentials (e.g. keeping secrets in environment variables: process.env.SECRET)",
      severity: 2,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.jsonwebtoken.security.jwt-hardcode.hardcoded-jwt-secret",
      ruleset: "typescript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: true,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19006,
      syntacticId: "bcb400eda5543457651a42c41d6688e2",
      matchBasedId: null,
      check_id:
        "javascript.jsonwebtoken.security.jwt-hardcode.hardcoded-jwt-secret",
      path: "lib/insecurity.js",
      line: 34,
      column: 33,
      end_line: 34,
      end_column: 112,
      message:
        "Hardcoded JWT secret or private key is used. This is a Insufficiently Protected Credentials weakness: https://cwe.mitre.org/data/definitions/522.html Consider using an appropriate security mechanism to protect the credentials (e.g. keeping secrets in environment variables: process.env.SECRET)",
      severity: 2,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.jsonwebtoken.security.jwt-hardcode.hardcoded-jwt-secret",
      ruleset: "typescript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19005,
      syntacticId: "d80d7d7faba108a84b14cadfe47ec156",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.audit.prototype-pollution.prototype-pollution-loop.prototype-pollution-loop",
      path: "frontend/src/hacking-instructor/helpers/helpers.ts",
      line: 29,
      column: 9,
      end_line: 29,
      end_column: 54,
      message:
        "Possibility of prototype polluting function detected. By adding or modifying attributes of an object prototype, it is possible to create attributes that exist on every object, or replace critical attributes with malicious ones. This can be problematic if the software depends on existence or non-existence of certain attributes, or uses pre-defined attributes of object prototype (such as hasOwnProperty, toString or valueOf). Possible mitigations might be: freezing the object prototype, using an object without prototypes (via Object.create(null) ), blocking modifications of attributes that resolve to object prototype, using Map instead of object.",
      severity: 1,
      references: [
        "https://github.com/HoLyVieR/prototype-pollution-nsec18/blob/master/paper/JavaScript_prototype_pollution_attack_in_NodeJS.pdf",
      ],
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.audit.prototype-pollution.prototype-pollution-loop.prototype-pollution-loop",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19004,
      syntacticId: "01433b3ce37e3258f2b2ad9450e99176",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.detect-eval-with-expression.detect-eval-with-expression",
      path: "routes/userProfile.ts",
      line: 33,
      column: 26,
      end_line: 33,
      end_column: 36,
      message:
        "Detected eval(variable), which could allow a malicious actor to run arbitrary code.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.detect-eval-with-expression.detect-eval-with-expression",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: true,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19003,
      syntacticId: "fb67a90a6ca102ae50d08dc37e8c55e2",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.detect-eval-with-expression.detect-eval-with-expression",
      path: "routes/captcha.ts",
      line: 23,
      column: 20,
      end_line: 23,
      end_column: 36,
      message:
        "Detected eval(variable), which could allow a malicious actor to run arbitrary code.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.detect-eval-with-expression.detect-eval-with-expression",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: true,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19002,
      syntacticId: "e1a96959133e4a722e7cd015cffbd55e",
      matchBasedId: null,
      check_id: "ajinabraham.njsscan.hardcoded_secrets.node_username",
      path: "data/datacreator.ts",
      line: 251,
      column: 9,
      end_line: 251,
      end_column: 29,
      message:
        "A hardcoded username in plain text is identified. Store it properly in an environment variable.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/ajinabraham.njsscan.hardcoded_secrets.node_username",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: true,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19001,
      syntacticId: "462174f1040d3ebc15dc2fb9ef54d76c",
      matchBasedId: null,
      check_id: "ajinabraham.njsscan.hardcoded_secrets.node_username",
      path: "data/datacreator.ts",
      line: 247,
      column: 9,
      end_line: 247,
      end_column: 29,
      message:
        "A hardcoded username in plain text is identified. Store it properly in an environment variable.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/ajinabraham.njsscan.hardcoded_secrets.node_username",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      reviewComments: [{ id: 1, body: "This is a comment" }],
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
  }),
  ListIssuesResponse_IssueSummary.create({
    allRefs: ["refs/heads/master", "refs/heads/1", "refs/heads/2"],
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 19000,
      syntacticId: "d6700b74266184689822f98827657e93",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      path: "routes/vulnCodeSnippet.ts",
      line: 124,
      column: 24,
      end_line: 124,
      end_column: 86,
      message:
        "RegExp() called with a variable, this might allow an attacker to DOS your application with a long-running regular expression.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      lastSeenScan: {
        id: 32379,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 18999,
      syntacticId: "f122401dd5aebca4ee977e62287ed707",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      path: "routes/vulnCodeSnippet.ts",
      line: 122,
      column: 17,
      end_line: 122,
      end_column: 76,
      message:
        "RegExp() called with a variable, this might allow an attacker to DOS your application with a long-running regular expression.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/master",
      id: 18998,
      syntacticId: "8a1dcdfb5f070e7c5a4e2011b1ab42cb",
      matchBasedId: null,
      check_id:
        "javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      path: "routes/vulnCodeSnippet.ts",
      line: 103,
      column: 21,
      end_line: 103,
      end_column: 76,
      message:
        "RegExp() called with a variable, this might allow an attacker to DOS your application with a long-running regular expression.",
      severity: 1,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp",
      ruleset: "javascript",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/juice-shop",
      },
      firstSeenScan: {
        id: 32374,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/juice-shop",
          repo_url: "https://github.com/jesse-r2c/juice-shop",
          branch: "refs/heads/master",
          ci_job_url:
            "https://github.com/jesse-r2c/juice-shop/actions/runs/2282792114",
          commit: "05b4b5f83d014bb1b655590e4326c113b636137e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Fri, 06 May 2022 16:06:10 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 18996,
      syntacticId: "6ab36e11010d0b0ed2c7cd1c6c79a278",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 3,
      column: 1,
      end_line: 3,
      end_column: 13,
      message:
        "This expression is always True: `true == true` or `true != true`. If testing for floating point NaN, use `math.isnan(true)`, or `cmath.isnan(true)` if the number is complex.",
      severity: 2,
      policy_slug: "rule-board-audit",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      ruleset: "python",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/public-vuln-testing",
      },
      firstSeenScan: {
        id: 32372,
        meta: {
          semgrep_version: "0.91.0",
          repository: "jesse-r2c/public-vuln-testing",
          repo_url: "https://github.com/jesse-r2c/public-vuln-testing",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/public-vuln-testing/actions/runs/2277243928",
          commit: "c250ba27da9f0dd5848b693e121fca4b78cd15f4",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Thu, 05 May 2022 17:28:06 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10969,
      syntacticId: "f022c77fd3e3e080387b8d6408165202",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 14,
      column: 1,
      message:
        "This expression is always True: `13 == 13` or `13 != 13`. If testing for floating point NaN, use `math.isnan(13)`, or `cmath.isnan(13)` if the number is complex.",
      severity: 2,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10968,
      syntacticId: "22720f9ed732637e84098fb9c4844afe",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 13,
      column: 1,
      message:
        "This expression is always True: `12 == 12` or `12 != 12`. If testing for floating point NaN, use `math.isnan(12)`, or `cmath.isnan(12)` if the number is complex.",
      severity: 2,
      index: 0,
      end_line: 13,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10967,
      syntacticId: "cb988c93a507ab1ba7b4c196875c3627",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 25,
      column: 1,
      message:
        "This expression is always True: `24 == 24` or `24 != 24`. If testing for floating point NaN, use `math.isnan(24)`, or `cmath.isnan(24)` if the number is complex.",
      severity: 2,
      end_line: 25,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10966,
      syntacticId: "3b07bbfaef092578c04f33aa4d8b1421",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 26,
      column: 1,
      message:
        "This expression is always True: `25 == 25` or `25 != 25`. If testing for floating point NaN, use `math.isnan(25)`, or `cmath.isnan(25)` if the number is complex.",
      severity: 2,
      end_line: 26,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10965,
      syntacticId: "bcccb726e7ad975126c4253fa170d574",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 24,
      column: 1,
      message:
        "This expression is always True: `23 == 23` or `23 != 23`. If testing for floating point NaN, use `math.isnan(23)`, or `cmath.isnan(23)` if the number is complex.",
      severity: 2,
      end_line: 24,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10964,
      syntacticId: "437daae75f2b47e721c4653773859de1",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 23,
      column: 1,
      message:
        "This expression is always True: `22 == 22` or `22 != 22`. If testing for floating point NaN, use `math.isnan(22)`, or `cmath.isnan(22)` if the number is complex.",
      severity: 2,
      end_line: 23,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10963,
      syntacticId: "0da5d81f6d04b8861a370f1277b5eef3",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 17,
      column: 1,
      message:
        "This expression is always True: `16 == 16` or `16 != 16`. If testing for floating point NaN, use `math.isnan(16)`, or `cmath.isnan(16)` if the number is complex.",
      severity: 2,
      end_line: 17,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10962,
      syntacticId: "e2f9ec3c349cc8e77fa0d6cb680d666f",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 22,
      column: 1,
      message:
        "This expression is always True: `21 == 21` or `21 != 21`. If testing for floating point NaN, use `math.isnan(21)`, or `cmath.isnan(21)` if the number is complex.",
      severity: 2,
      end_line: 22,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10961,
      syntacticId: "9f009fd67f768cab757dd3dbcfaffe99",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 21,
      column: 1,
      message:
        "This expression is always True: `20 == 20` or `20 != 20`. If testing for floating point NaN, use `math.isnan(20)`, or `cmath.isnan(20)` if the number is complex.",
      severity: 2,
      end_line: 21,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10960,
      syntacticId: "4aaa6096c56c6dc4878e23f86ada57a5",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 18,
      column: 1,
      message:
        "This expression is always True: `17 == 17` or `17 != 17`. If testing for floating point NaN, use `math.isnan(17)`, or `cmath.isnan(17)` if the number is complex.",
      severity: 2,
      end_line: 18,
      end_column: 9,
      poliyc_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10959,
      syntacticId: "2153ad2cc7b5657a15a2bb3fee4107b6",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 30,
      column: 1,
      message:
        "This expression is always True: `29 == 29` or `29 != 29`. If testing for floating point NaN, use `math.isnan(29)`, or `cmath.isnan(29)` if the number is complex.",
      severity: 2,
      end_line: 30,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10958,
      syntacticId: "c50b88292f7510daed80de5e2a5b4243",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 29,
      column: 1,
      message:
        "This expression is always True: `28 == 28` or `28 != 28`. If testing for floating point NaN, use `math.isnan(28)`, or `cmath.isnan(28)` if the number is complex.",
      severity: 2,
      end_line: 29,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10957,
      syntacticId: "22ed6e13babf4944119cebd22cb85e9f",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 27,
      column: 1,
      message:
        "This expression is always True: `26 == 26` or `26 != 26`. If testing for floating point NaN, use `math.isnan(26)`, or `cmath.isnan(26)` if the number is complex.",
      severity: 2,
      end_line: 27,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10956,
      syntacticId: "16e1e93f2cc8e9bbbb71c11eb27d0ce5",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 20,
      column: 1,
      message:
        "This expression is always True: `19 == 19` or `19 != 19`. If testing for floating point NaN, use `math.isnan(19)`, or `cmath.isnan(19)` if the number is complex.",
      severity: 2,
      end_line: 20,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10955,
      syntacticId: "e5723492cb80abc645046a179a272c1c",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 28,
      column: 1,
      message:
        "This expression is always True: `27 == 27` or `27 != 27`. If testing for floating point NaN, use `math.isnan(27)`, or `cmath.isnan(27)` if the number is complex.",
      severity: 2,
      end_line: 28,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10954,
      syntacticId: "b812ccde7658d2112cb931f78d21bc0f",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 19,
      column: 1,
      message:
        "This expression is always True: `18 == 18` or `18 != 18`. If testing for floating point NaN, use `math.isnan(18)`, or `cmath.isnan(18)` if the number is complex.",
      severity: 2,
      end_line: 19,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10953,
      syntacticId: "0a68858f2ba31c54f0a8ac60b30b89db",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 15,
      column: 1,
      message:
        "This expression is always True: `14 == 14` or `14 != 14`. If testing for floating point NaN, use `math.isnan(14)`, or `cmath.isnan(14)` if the number is complex.",
      severity: 2,
      end_line: 15,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10952,
      syntacticId: "294231a58be5e5df398f7bd6706fef80",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 16,
      column: 1,
      message:
        "This expression is always True: `15 == 15` or `15 != 15`. If testing for floating point NaN, use `math.isnan(15)`, or `cmath.isnan(15)` if the number is complex.",
      severity: 2,
      end_line: 16,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18448,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2016688939",
          commit: "453b5e3ceb703b3a5ff7f041628eae146a31d447",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: "jesse-r2c",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/99560876?v=4",
          commit_title: "Merge pull request #4 from jesse-r2c/branch2",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Mon, 21 Mar 2022 14:25:15 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10951,
      syntacticId: "416acc021a4acf123c8aea23cd062793",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 11,
      column: 1,
      message:
        "This expression is always True: `False == False` or `False != False`. If testing for floating point NaN, use `math.isnan(False)`, or `cmath.isnan(False)` if the number is complex.",
      severity: 2,
      end_line: 11,
      end_column: 15,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18411,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2010511128",
          commit: "4dfd40373adc4f99d9d0fd70393fe695226be9a9",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: null,
          commit_author_image_url: null,
          commit_title: "Merge pull request #2 from jesse-r2c/branch2",
          on: "schedule",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Sun, 20 Mar 2022 02:30:35 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10950,
      syntacticId: "89706d1f1df222e28ca0de6590440f35",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 10,
      column: 1,
      message:
        "This expression is always True: `11 == 11` or `11 != 11`. If testing for floating point NaN, use `math.isnan(11)`, or `cmath.isnan(11)` if the number is complex.",
      severity: 2,
      end_line: 10,
      end_column: 9,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18411,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/2010511128",
          commit: "4dfd40373adc4f99d9d0fd70393fe695226be9a9",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: null,
          commit_author_image_url: null,
          commit_title: "Merge pull request #2 from jesse-r2c/branch2",
          on: "schedule",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Sun, 20 Mar 2022 02:30:35 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10944,
      syntacticId: "07a0f70e4362370f176067fbcb874d34",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 8,
      column: 1,
      message:
        "This expression is always True: `True == True` or `True != True`. If testing for floating point NaN, use `math.isnan(True)`, or `cmath.isnan(True)` if the number is complex.",
      severity: 2,
      end_line: 8,
      end_column: 13,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18051,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1939902888",
          commit: "367b7d301039be96c7775908c6d992d1b60c09ba",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: null,
          commit_author_image_url: null,
          commit_title: "Merge pull request #1 from jesse-r2c/branch1",
          on: "schedule",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Sun, 06 Mar 2022 02:30:45 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10943,
      syntacticId: "4452275dd0c0849c01dfb99b32bb8134",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 7,
      column: 1,
      message:
        "This expression is always True: `0 == 0` or `0 != 0`. If testing for floating point NaN, use `math.isnan(0)`, or `cmath.isnan(0)` if the number is complex.",
      severity: 2,
      end_line: 7,
      end_column: 7,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 18051,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1939902888",
          commit: "367b7d301039be96c7775908c6d992d1b60c09ba",
          commit_author_email: "99560876+jesse-r2c@users.noreply.github.com",
          commit_author_name: "jesse-r2c",
          commit_author_username: null,
          commit_author_image_url: null,
          commit_title: "Merge pull request #1 from jesse-r2c/branch1",
          on: "schedule",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Sun, 06 Mar 2022 02:30:45 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10940,
      syntacticId: "25c7c8adf8dde8b4d54c0aab540f520e",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 1,
      column: 1,
      message:
        "This expression is always True: `5 == 5` or `5 != 5`. If testing for floating point NaN, use `math.isnan(5)`, or `cmath.isnan(5)` if the number is complex.",
      severity: 2,
      end_line: 1,
      end_column: 7,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 17948,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1917722301",
          commit: "3ecc526bae7d4ba4b6451f0a30e75f7026ce341e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Tue, 01 Mar 2022 17:36:09 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10939,
      syntacticId: "1df6609b135b381b58170bb8e23bd659",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 4,
      column: 1,
      message:
        "This expression is always True: `6 == 6` or `6 != 6`. If testing for floating point NaN, use `math.isnan(6)`, or `cmath.isnan(6)` if the number is complex.",
      severity: 2,
      end_line: 4,
      end_column: 7,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 17948,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1917722301",
          commit: "3ecc526bae7d4ba4b6451f0a30e75f7026ce341e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Tue, 01 Mar 2022 17:36:09 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10938,
      syntacticId: "d11ebddc712c29eeec981d6074bc1f9d",
      matchBasedId: null,
      check_id: "python.lang.correctness.useless-eqeq.useless-eqeq",
      path: "bad.py",
      line: 8,
      column: 1,
      message:
        "This expression is always True: `9 == 9` or `9 != 9`. If testing for floating point NaN, use `math.isnan(9)`, or `cmath.isnan(9)` if the number is complex.",
      severity: 2,
      end_line: 8,
      end_column: 7,
      commit_date: "2022-03-01T17:35:33+00:00",
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.useless-eqeq.useless-eqeq",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 17948,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1917722301",
          commit: "3ecc526bae7d4ba4b6451f0a30e75f7026ce341e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triage_state: "reopened",
      relevantSince: new Date(Date.parse("Tue, 01 Mar 2022 17:36:09 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: "Cool beans",
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
  ListIssuesResponse_IssueSummary.create({
    issue: Issue.create({
      ref: "refs/heads/main",
      id: 10935,
      syntacticId: "fbe84f24a12c201e7958c139b9bf74f2",
      matchBasedId: null,
      check_id:
        "python.lang.correctness.common-mistakes.string-concat-in-list.string-concat-in-list",
      path: "bad.py",
      line: 3,
      column: 16,
      message:
        "Detected strings that are implicitly concatenated inside a list. Python will implicitly concatenate strings when not explicitly delimited. Was this supposed to be individual elements of the list?",
      severity: 1,
      end_line: 3,
      end_column: 29,
      policy_slug: "rule-board-audit",
      ruleset: "python",
      rule_url:
        "https://semgrep.dev/r/python.lang.correctness.common-mistakes.string-concat-in-list.string-concat-in-list",
      status: IssueStatus.UNRESOLVED,
      repository: {
        name: "jesse-r2c/findings-test",
      },
      firstSeenScan: {
        id: 17948,
        meta: {
          repository: "jesse-r2c/findings-test",
          repo_url: "https://github.com/jesse-r2c/findings-test",
          branch: "refs/heads/main",
          ci_job_url:
            "https://github.com/jesse-r2c/findings-test/actions/runs/1917722301",
          commit: "3ecc526bae7d4ba4b6451f0a30e75f7026ce341e",
          commit_author_email: "support@r2c.dev",
          commit_author_name: "semgrep.dev on behalf of @jesse-r2c",
          commit_author_username: "dev-semgrep-app[bot]",
          commit_author_image_url:
            "https://avatars.githubusercontent.com/u/29760937?v=4",
          commit_title: "Add Semgrep CI",
          on: "push",
          pull_request_author_username: null,
          pull_request_author_image_url: null,
          pull_request_id: null,
          pull_request_title: null,
          scan_environment: "github-actions",
          is_full_scan: true,
          ignored_files: [],
        },
      },
      removedByPrEvent: false,
      triageState: FindingTriageState.UNTRIAGED,
      relevantSince: new Date(Date.parse("Tue, 01 Mar 2022 17:36:09 GMT")),
      aggregateState: AggregateIssueState.OPEN,
      note: null,
      isBlocking: false,
      createdAt: new Date(Date.parse("Fri, 02 May 2022 16:06:10 GMT")),
    }),
    reviewComments: [],
  }),
];
